<template>
  <KeypadSetting
    :tag="tag"
    :prefix="cellPrefix"
    :reference="cellReference"
    :disableInvertKey="disableInvertKey"
    :disableAbsoluteValue="cellDisableAbsoluteValue"
    :popoverTitle="popoverTitle"
    :popoverPrefix="popoverPrefix"
    :popoverReference="popoverReference"
    :popoverDisableAbsoluteValue="popoverDisableAbsoluteValue"
    :selectedCells="selectedCells"
    :getSubmitPopoverReferenceTag="getSubmitPopoverReferenceTag"
    :getSubmitValues="getSubmitValues"
    v-model:showingPopover="showingPopover"
    >
    <template #HelpText>
      <div style="flex-grow: 1; display: flex; flex-direction: column; gap: 15px;">
        <p>
          Defines how {{ reconditioning ? 'warm' : 'cool' }} the outside air must be, in comparison to the
        </p>
        <Dropdown v-model="popoverReferenceCode" :options="referenceOptions" optionLabel="text" optionValue="value" />
        <p>
          for the outside air to be considered available.
        </p>
      </div>
    </template>
    <template #BinSelectionInput>
      <slot name="BinSelectionInput"></slot>
    </template>
  </KeypadSetting>
</template>

<script setup>
import { computed } from "vue";
import { useKeypadReferenceOptions } from "./KeypadUtility.js";
import KeypadSetting from "./KeypadSetting.vue";

let props = defineProps([
  "tag",
  "prefix",
  "readOnly",
  "referenceSelector",
  "referenceOptions",
  "reconditioning",
  "disableInvertKey",
  "showingPopover",
  "popoverTitle",
  "selectedCells",
  "applyToAllBins",
  "validator",
]);

let showingPopover = defineModel("showingPopover");

let {
  cellPrefix,
  cellReference,
  cellReferenceCode,
  popoverReferenceCode,
  popoverPrefix,
  popoverReference,
  getSubmitPopoverReferenceTag,
  getSubmitValues
}  = useKeypadReferenceOptions(props, showingPopover);

let cellDisableAbsoluteValue = computed(() => {
  return cellReferenceCode.value == "controlTemp";
});

let popoverDisableAbsoluteValue = computed(() => {
  return popoverReferenceCode.value == "controlTemp";
});
</script>